import {
  DELETE_RESTAURANT_CATEGORY_FAILURE,
  DELETE_RESTAURANT_CATEGORY_REQUEST,
  DELETE_RESTAURANT_CATEGORY_SUCCESS,
  GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE,
  GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
  GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS,
  POST_RESTAURANT_CATEGORY_FAILURE,
  POST_RESTAURANT_CATEGORY_REQUEST,
  POST_RESTAURANT_CATEGORY_SUCCESS,
  PUT_RESTAURANT_CATEGORY_FAILURE,
  PUT_RESTAURANT_CATEGORY_REQUEST,
  PUT_RESTAURANT_CATEGORY_SUCCESS,
  GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
  PUT_RESTAURANT_VARIANT_SUCCESS,
  PUT_RESTAURANT_VARIANT_FAILURE,
  GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS,
  GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE,
  PUT_RESTAURANT_VARIANT_REQUEST,
  POST_RESTAURANT_VARIANT_REQUEST,
  POST_RESTAURANT_VARIANT_SUCCESS,
  POST_RESTAURANT_VARIANT_FAILURE,
  DELETE_RESTAURANT_VARIANT_REQUEST,
  DELETE_RESTAURANT_VARIANT_SUCCESS,
  DELETE_RESTAURANT_VARIANT_FAILURE,
} from "../../../Utils/Constant";

// Get All Reservation List Details
export const getAllRestaurantCategoryListRequest = (payload) => {
  return {
    type: GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
    payload,
  };
};

export const getAllRestaurantCategoryListSuccess = (data) => {
  return {
    type: GET_ALL_RESTAURANT_CATEGORY_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllRestaurantCategoryListFailure = (error) => {
  return {
    type: GET_ALL_RESTAURANT_CATEGORY_LIST_FAILURE,
    payload: error,
  };
};

// Add Category 

export const addRestaurantCategoryRequest = (payload) => {
  return {
    type: POST_RESTAURANT_CATEGORY_REQUEST,
    payload,
  };
};

export const addRestaurantCategorySuccess = (data) => {
  return {
    type: POST_RESTAURANT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const addRestaurantCategoryFailure = (error) => {
  return {
    type: POST_RESTAURANT_CATEGORY_FAILURE,
    payload: error,
  };
};

export const updateRestaurantCategoryRequest = (payload) => {
  return {
    type: PUT_RESTAURANT_CATEGORY_REQUEST,
    payload,
  };
};

export const updateRestaurantCategorySuccess = (data) => {
  return {
    type: PUT_RESTAURANT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const updateRestaurantCategoryFailure = (error) => {
  return {
    type: PUT_RESTAURANT_CATEGORY_FAILURE,
    payload: error,
  };
};

export const deleteRestaurantCategoryRequest = (payload) => {
  return {
    type: DELETE_RESTAURANT_CATEGORY_REQUEST,
    payload,
  };
};

export const deleteRestaurantCategorySuccess = (data) => {
  return {
    type: DELETE_RESTAURANT_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const deleteRestaurantCategoryFailure = (error) => {
  return {
    type: DELETE_RESTAURANT_CATEGORY_FAILURE,
    payload: error,
  };
};


export const updateRestaurantVariantRequest = (payload) => {
  return {
    type: PUT_RESTAURANT_VARIANT_REQUEST,
    payload,
  };
};

export const updateRestaurantVariantSuccess = (data) => {
  return {
    type: PUT_RESTAURANT_VARIANT_SUCCESS,
    payload: data,
  };
};

export const updateRestaurantVariantFailure = (error) => {
  return {
    type: PUT_RESTAURANT_VARIANT_FAILURE,
    payload: error,
  };
};

// Get All Reservation List Details
export const getAllRestaurantVariantListRequest = (payload) => {
  return {
    type: GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
    payload,
  };
};
export const getAllRestaurantVariantListSuccess = (data) => {
  return {
    type: GET_ALL_RESTAURANT_VARIANT_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllRestaurantVariantListFailure = (error) => {
  return {
    type: GET_ALL_RESTAURANT_VARIANT_LIST_FAILURE,
    payload: error,
  };
};

export const addRestaurantVarientRequest = (payload) => {
  return {
    type: POST_RESTAURANT_VARIANT_REQUEST,
    payload,
  };
};
export const addRestaurantVarientSuccess = (data) => {
  return {
    type: POST_RESTAURANT_VARIANT_SUCCESS,
    payload: data,
  };
};

export const addRestaurantVarientFailure = (error) => {
  return {
    type: POST_RESTAURANT_VARIANT_FAILURE,
    payload: error,
  };
};

export const deleteRestaurantVarientRequest = (payload) => {
  return {
    type: DELETE_RESTAURANT_VARIANT_REQUEST,
    payload,
  };
};

export const deleteRestaurantVarientSuccess = (data) => {
  return {
    type: DELETE_RESTAURANT_VARIANT_SUCCESS,
    payload: data,
  };
};

export const deleteRestaurantVarientFailure = (error) => {
  return {
    type: DELETE_RESTAURANT_VARIANT_FAILURE,
    payload: error,
  };
};